<template>
    <div class="page">
        <div class="topView">
            <div class="topViewL" v-if="detailData != null">
                <div></div>
                <div>虚拟订单详情</div>
                <el-popover placement="right-end" width="800" trigger="click">
                    <el-table :data="detailData.trace_list" style="width: 100%">
                        <el-table-column prop="track_desc" label="描述">
                        </el-table-column>
                        <el-table-column prop="track_desc" label="订单状态">
                            <template slot-scope='scope'>
                                <span v-if="scope.row.state == 1">已创建</span>
                                <span v-if="scope.row.state == 2">支付中</span>
                                <span v-if="scope.row.state == 3">支付成功</span>
                                <span v-if="scope.row.state == 4">已接单</span>
                                <span v-if="scope.row.state == 5">已发货</span>
                                <span v-if="scope.row.state == 8">已完成</span>
                                <span v-if="scope.row.state == -2">已取消</span>
                                <span v-if="scope.row.state == -3">退款中</span>
                                <span v-if="scope.row.state == -4">退款成功</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remarks" label="备注">
                        </el-table-column>
                        <el-table-column label="操作时间">
                            <template slot-scope='scope'>
                                {{ $public.FTime(scope.row.track_time) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作人">
                            <template slot-scope='scope'>
                                {{ scope.row.handlers }}
                            </template>
                        </el-table-column>
                    </el-table>
                    <i slot="reference" class="el-icon-view" style="margin-left: 10px;color:#409EFF;"></i>
                </el-popover>
            </div>
            <div class="topViewR" v-if="detailData != null">
                <el-button type="warning" plain @click="handleBackClick">返回</el-button>
            </div>
        </div>

        <div class="detailView" v-if="detailData != null">
            <div class="detailViewName">订单信息</div>
            <div class="detailRow">
                <div class="detailCol">
                    <div>订单编号：</div>
                    <div>{{ detailData.no }}</div>
                </div>
                <div class="detailCol">
                    <div>订单类型：</div>
                    <div>虚拟</div>
                </div>
                <div class="detailCol">
                    <div>订单状态：</div>
                    <div v-if="detailData.state == 1">已创建</div>
                    <div v-if="detailData.state == 2">支付中</div>
                    <div v-if="detailData.state == 3">支付成功</div>
                    <div v-if="detailData.state == 5">已发货</div>
                    <div v-if="detailData.state == 8">已完成</div>
                    <div v-if="detailData.state == -2">已取消</div>
                    <div v-if="detailData.state == -3">退款中</div>
                    <div v-if="detailData.state == -4">退款成功</div>
                </div>
                <div class="detailCol">
                    <div>下单时间：</div>
                    <div>{{ $public.FTime(detailData.create_time, "YYYY-MM-DD HH:mm:ss") }}</div>
                </div>
            </div>
            <div class="detailRow">
                <div class="detailCol">
                    <div>用户名：</div>
                    <div>{{ detailData.user_info.nick_name }}</div>
                </div>
                <div class="detailCol">
                    <div>电话：</div>
                    <div>{{ detailData.user_info.user_mobile }}</div>
                </div>
                <div class="detailCol">
                    <div>订单备注：</div>
                    <div>{{ detailData.remark }}</div>
                </div>
                <div class="detailCol">
                    <div>结算方式：</div>
                    <template v-if="detailData.pay_info != null">
                        <span v-for="(item, index) in detailData.pay_info.pay_list" :key="index">
                            <template v-if="item.pay_type == 1">支付宝</template>
                            <template v-if="item.pay_type == 2">微信</template>
                            <template v-if="item.pay_type == 7">余额</template>
                            <template v-if="item.pay_type == 17">拉卡拉</template>
                            <template v-if="item.pay_type == 9">积分</template>
                        </span>
                    </template>
                </div>
            </div>
            <div class="detailRow">
                <div class="detailCol">
                    <div>优惠券：</div>
                    <div>{{ detailData.coupon_list.length != 0 ? detailData.coupon_list[0].coupon_name : '--' }}</div>
                </div>
                <div class="detailCol">
                    <div>优惠金额：</div>
                    <div>{{ (detailData.order_price + detailData.postage - detailData.total_price).toFixed(2) }}</div>
                </div>
                <div class="detailCol">
                    <div>总计金额：</div>
                    <div>{{ detailData.total_price }}</div>
                </div>
                <div class="detailCol">
                    <div>交易平台：</div>
                    <div>{{ detailData.order_platform }}</div>
                </div>
               
            </div>
            <div class="detailRow">
                <div class="detailCol">
                    <div>动账金额：</div>
                    <div>
                        {{ detailData.online_order_data && detailData.online_order_data.distribution_money }}
                        <el-tooltip class="item" effect="dark" placement="top-start">
                            <div slot="content">
                                受益人：{{ dongzhangDetail && dongzhangDetail.commissionInfo &&
                                    dongzhangDetail.commissionInfo.userName }}
                            </div>
                            <i class="el-icon-view" style="margin-left: 10px;color:#409EFF;"></i>
                        </el-tooltip>
                    </div>
                </div>
                <div class="detailCol">
                    <div>pos费率：</div>
                    <div>0.6%</div>
                </div>
                <div class="detailCol">
                    <div>手续费：</div>
                    <div>{{ $public.cheng(detailData.total_price, 0.006) }}</div>
                </div>
                <div class="detailCol">
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>

        <div class="tableWrap">
            <div class="tableView" v-if="detailData != null">
                <el-table :data="detailData.order_item_list" style="width: 100%">
                    <el-table-column prop="goods_name" label="券名">
                    </el-table-column>
                    <el-table-column prop="original_price" label="标准价">
                    </el-table-column>
                    <el-table-column label="活动">
                        <template slot-scope='scope'>
                            {{ scope.row.activity_info == null ? '--' : scope.row.activity_info.activity_name }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="优惠价">
                    </el-table-column>
                    <el-table-column prop="num" label="数量">
                    </el-table-column>
                    <el-table-column label="支付金额">
                        <template slot-scope="scope">{{ scope.row.price * scope.row.num }}</template>
                    </el-table-column>
                    <!-- <el-table-column label="操作" width="80">
						<template>
							<el-button @click="drawerBiangenghuoti_state = true" type="text" size="small" v-if="detailData.state == 3">变更</el-button>
						</template>
					</el-table-column> -->
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            id: this.$route.query.id,
            tableData: [],
            code: '',
            online_order_data: null,
            dongzhangDetail: {
                commissionInfo: {},
            },
            detailData: null
        }
    },
    mounted() {
        console.log(this.id)
        this.getDetailData()
    },
    methods: {
        //获取详情
        getDetailData() {
            let params = {
                id: this.id
            }
            let loading = this.$loading();
            this.$http.get(process.env.VUE_APP_Url_order + '/api/OnLineOrder/get', params).then((res) => {
                if (res.code == 0) {
                    this.online_order_data = res.data.online_order_data;
                    this.detailData = res.data;
                    loading.close()
                }
            })
        },
        //返回
        handleBackClick() {
            this.$router.back();
        }
    }
}
</script>

<style lang="scss" scoped>
.page {
    padding: 16px 16px 0 16px;
    height: 100%;
    box-sizing: border-box;

    .topView {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;

        .topViewL {
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #343440;
            font-weight: bold;

            div:nth-of-type(1) {
                width: 5px;
                height: 20px;
                background: linear-gradient(315deg, #338AFF 0%, #3F69FF 100%);
                border-radius: 4px;
                margin-right: 12px;
            }
        }
    }

    .detailView {
        margin-bottom: 16px;
        padding: 24px 32px;
        background: #fff;
        border-radius: 16px;

        .detailViewName {
            font-size: 16px;
            font-weight: bold;
            color: #343440;
        }

        .detailRow {
            display: flex;
            align-items: center;
            margin-top: 32px;
            font-size: 14px;
            justify-content: space-between;

            .detailCol {
                display: flex;
                align-items: center;
                width: 24%;

                div:nth-of-type(1) {
                    width: 70px;
                    text-align: right;
                    color: #343440;
                    font-weight: 400;
                }

                div:nth-of-type(2) {
                    flex: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    color: #343440;
                    font-weight: 500;
                }
            }
        }

    }

    .tableWrap {
        padding: 16px;
        background: #fff;
        border-radius: 8px;
        height: 440px;
    }
}
</style>
